import {useCheckConfirmationToken, CheckResult} from 'hooks/api/useCheckConfirmationToken'

export const useCheckChangeEmailConfirmationToken = (token?: string): CheckResult =>
  useCheckConfirmationToken('/api/change_email_confirmation', {params: {confirmation_token: token}})
